import { useQuery } from "@tanstack/react-query";

import { getExchangeRates, type ExchangeRates } from "@/lib/currency.functions";
import { FALLBACK_RATES } from "./config";

const FALLBACK: ExchangeRates = { base: "GBP", rates: FALLBACK_RATES, fetchedAt: 0, source: "fallback" };

/** GBP-based exchange rates, refreshed at most once an hour. Display only. */
export function useExchangeRates() {
  const query = useQuery({
    queryKey: ["exchange-rates"],
    queryFn: () => getExchangeRates(),
    staleTime: 60 * 60 * 1000,
    gcTime: 2 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
  return query.data ?? FALLBACK;
}
